// extracted by mini-css-extract-plugin
export default {"button":"MarketingPromoButton__button--3YKSY"};